export default {
  modules: {
    map: {
      key: 'Map',
      namespace: 'esri/Map'
    },
    webMap: {
      key: 'WebMap',
      namespace: 'esri/WebMap'
    },
    mapView: {
      key: 'MapView',
      namespace: 'esri/views/MapView'
    },
    extent: {
      key: 'Extent',
      namespace: 'esri/geometry/Extent'
    },
    geometryEngine: {
      key: 'GeometryEngine',
      namespace: 'esri/geometry/geometryEngine'
    },
    spatialReference: {
      key: 'SpatialReference',
      namespace: 'esri/geometry/SpatialReference'
    },
    webMercatorUtils: {
      key: 'WebMercatorUtils',
      namespace: 'esri/geometry/support/webMercatorUtils'
    },
    graphic: {
      key: 'Graphic',
      namespace: 'esri/Graphic'
    },
    graphicsLayer: {
      key: 'GraphicsLayer',
      namespace: 'esri/layers/GraphicsLayer'
    },
    sketchViewModel: {
      key: 'SketchViewModel',
      namespace: 'esri/widgets/Sketch/SketchViewModel'
    },
    featureLayer: {
      key: 'FeatureLayer',
      namespace: 'esri/layers/FeatureLayer'
    },
    config: {
      key: 'Config',
      namespace: 'esri/config'
    },
    polygon: {
      key: 'Polygon',
      namespace: 'esri/geometry/Polygon'
    },
    portalItem: {
      key: 'PortalItem',
      namespace: 'esri/portal/PortalItem'
    },
    point: {
      key: 'Point',
      namespace: 'esri/geometry/Point'
    },
    watchUtils: {
      key: 'WatchUtils',
      namespace: 'esri/core/watchUtils'
    },
    identityManager: {
      key: 'IdentityManager',
      namespace: 'esri/identity/IdentityManager'
    },
    baseMap: {
      key: 'Basemap',
      namespace: 'esri/Basemap'
    },
    layer: {
      key: 'Layer',
      namespace: 'esri/layers/Layer'
    },
    tileInfo: {
      key: 'TileInfo',
      namespace: 'esri/layers/support/TileInfo'
    },
    handles: {
      key: 'Handles',
      namespace: 'esri/core/Handles'
    },
    baseLayerView2D: {
      key: 'BaseLayerView2D',
      namespace: 'esri/views/2d/layers/BaseLayerView2D'
    },
    projection: {
      key: 'Projection',
      namespace: 'esri/geometry/projection'
    }
  },
  wkid: 102100,
  worldMapExtent: {
    xMin: -20037507.073813,
    yMin: -19971868.872273,
    xMax: 20037507.061556,
    yMax: 19971868.88453
  },
  AUS_Extent: {
    xmin: 12342439.331260854,
    ymin: -5642887.17612344,
    xmax: 17390952.175438832,
    ymax: -990623.88657571
  },
  AUS_Extent_BCK: {
    xmin: 16133582,
    xmax: 16140557,
    ymin: -4556430,
    ymax: -4549398
  },
  polygonSymbol: {
    type: 'simple-fill',
    color: 'rgba(0, 112, 255, 0.25)',
    style: 'solid',
    outline: {
      color: 'rgba(0, 169, 230, 0.75)',
      width: 1
    }
  },
  polygonHighlightSymbol: {
    type: 'simple-fill',
    color: 'rgba(42, 209, 139, 0.5)',
    style: 'solid',
    outline: {
      color: '#0ccfff',
      width: 2
    }
  },
  polygonSymbolNoOutline: {
    type: 'simple-fill',
    color: 'rgba(0, 112, 255, 0.25)',
    style: 'solid',
    outline: {
      color: 'rgba(0, 112, 255, 0)',
      width: 1
    }
  },
  polygonDarkSymbol: {
    type: 'simple-fill',
    color: 'rgba(0, 89, 254, 0.35)',
    style: 'solid',
    outline: {
      color: '#ffffff',
      width: 1
    }
  },
  pointSymbol: {
    type: 'simple-marker',
    color: 'rgba(0, 112, 255, 0.50)',
    size: '16px',
    outline: {
      color: 'rgba(0, 197, 255, 0.75)',
      width: 1
    }
  },
  pointDarkSymbol: {
    type: 'simple-marker',
    color: 'rgba(0, 112, 255, 0.95)',
    size: '16px',
    outline: {
      color: 'rgba(255, 255, 255, 0.90)',
      width: 1
    }
  },
  zoomLevel: 17
};
